'use client';

import { useEffect } from 'react';

// Sets html[data-surface="sand"] on mount and clears it on unmount so the
// contact-route CSS overrides (cream bg + ink form fields) only apply while
// the visitor is on /contact.
export function SandSurfaceMount() {
  useEffect(() => {
    const html = document.documentElement;
    html.dataset.surface = 'sand';
    return () => {
      delete html.dataset.surface;
    };
  }, []);
  return null;
}
